import React from 'react'
// CSS
import '../assets/css/review-card.css';
// Images
import Avatar from '../assets/images/avatar.png';
import QuotionMark1 from '../assets/images/quotation-mark-1.png';
import QuotionMark2 from '../assets/images/quotation-mark-2.png';

export default function ReviewCard(props) {
  return (
    <div className="review_card">
      <div className="review_content">
        <img src={QuotionMark1} alt="Quotation Mark" className="quotation_mark_1 select_n" width="25px" />
        <div className="review_text">{props.reviewText}</div>
        <img src={QuotionMark2} alt="Quotation Mark" className="quotation_mark_2 select_n" width="25px" />
      </div>

      <div className="reviewer_info">
        <div className="reviewer_pic select_n">
          <img src={props.reviewerImage === ''? Avatar : props.reviewerImage} alt="Reviewer" />
        </div>
        <div className="details">
          <div className="reviewer_name">{props.reviewerName}</div>
          <div className="bio">{props.bio}</div>
        </div>
      </div>
    </div>
  )
}
